var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPreviousActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_55963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6052 20C38.6052 30.2752 30.2755 38.6048 20.0003 38.6048C9.72518 38.6048 1.39551 30.2752 1.39551 20C1.39551 9.72481 9.72518 1.39514 20.0003 1.39514C30.2755 1.39514 38.6052 9.72481 38.6052 20Z",
    fill: "white",
    stroke: "#6F525C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4305 20.0552C12.4305 20.4504 12.5818 20.8456 12.8843 21.1482L22.3603 30.6242C22.9654 31.2294 23.9412 31.2294 24.5462 30.6242C25.1513 30.0192 25.1513 29.0433 24.5462 28.443L16.1583 20.0552L24.5462 11.6673C25.1513 11.0622 25.1513 10.0864 24.5462 9.48617C23.9411 8.88107 22.9652 8.88107 22.3603 9.48617L12.8843 18.9621C12.5817 19.2647 12.4305 19.66 12.4305 20.0552Z",
    fill: "#706A85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_55963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPreviousActive);
export default __webpack_public_path__ + "static/media/arrow-previous-active.5b01391e02610f25e247d91bb668540c.svg";
export { ForwardRef as ReactComponent };